export const CHANGE_DEFAULT_PROFILE_ATTEMPT = 'CHANGE_DEFAULT_PROFILE_ATTEMPT';
export type CHANGE_DEFAULT_PROFILE_ATTEMPT = typeof CHANGE_DEFAULT_PROFILE_ATTEMPT;

export const CHANGE_DEFAULT_PROFILE_SUCCESS = 'CHANGE_DEFAULT_PROFILE_SUCCESS';
export type CHANGE_DEFAULT_PROFILE_SUCCESS = typeof CHANGE_DEFAULT_PROFILE_SUCCESS;

export const CHANGE_DEFAULT_PROFILE_FAILURE = 'CHANGE_DEFAULT_PROFILE_FAILURE';
export type CHANGE_DEFAULT_PROFILE_FAILURE = typeof CHANGE_DEFAULT_PROFILE_FAILURE;


// WEBPACK FOOTER //
// ./src/actions/default-profile/change/Types.tsx